import { Injectable } from '@angular/core';

/**
 * Holds the logo File selected during Account Setup (pre-login) in memory
 * so it can be uploaded to S3 once the user is authenticated in onboard-dashboard.
 * File objects cannot be serialized to localStorage, so this in-memory service
 * acts as a bridge across the signup → auto-login → onboarding navigation.
 */
@Injectable({ providedIn: 'root' })
export class PendingLogoService {
  private _file: File | null = null;

  set(file: File): void { this._file = file; }
  get(): File | null { return this._file; }
  has(): boolean { return this._file !== null; }
  clear(): void { this._file = null; }
}
